import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';
import './Link.scss';

class Link extends Component {
  render() {
    const {
      blank,
      children,
      to,
      additionalClass,
      underline,
      arrow,
      ...other
    } = this.props;
    const isInternal = /^\/(?!\/)/.test(to);

    let isExternal = true;
    if (typeof window !== 'undefined' && window.location) {
      isExternal = new RegExp(
        `^((f|ht)tps?:)?//(?!${window.location.host})`,
      ).test(to);
    }

    if ((to === '/' || isInternal) && !blank) {
      return (
        <GatsbyLink
          className={`link ${additionalClass} ${
            arrow ? 'link--anim-arrow' : ''
          } ${
            underline ? `link__underline link__underline--${underline}` : ''
          }`}
          to={to}
          {...other}
        >
          {children}
        </GatsbyLink>
      );
    }

    return (
      <a
        className={`link ${additionalClass} ${
          arrow ? 'link--anim-arrow' : ''
        } ${underline ? `link__underline link__underline--${underline}` : ''}`}
        href={to}
        rel={isExternal ? 'noopener noreferrer' : ''}
        target={isExternal || blank ? '_blank' : '_self'}
        {...other}
      >
        {children}
      </a>
    );
  }
}

Link.defaultProps = {
  additionalClass: '',
  underline: '',
  arrow: false,
  blank: false,
};

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  to: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
  underline: PropTypes.string,
  arrow: PropTypes.bool,
  blank: PropTypes.bool,
};

export default Link;
